import React from 'react'

function Admin() {


  return (
    <main>
        <section>
            <div className="container">
                <div className="row">

                </div>
            </div>
        </section>
    </main>
  )
}

export default Admin;